module.exports = __webpack_public_path__ + "img/d81c307.png";